// This allows us to define a publish schedule in advance and have these promos show/hide.
// The schedule is based on the current date and time. EX: unpublish_at: "2025-03-19T16:42:00" // please use this example set the time if needed

// For Cypress tests, use the test config to avoid dependency on real promotion schedules
import testConfig from './promoDrawsScheduleConfig.test.js';

let promoDrawsScheduleConfig = {
  // Promo Draws
  // "C362B105-A0B8-4F1E-B8DB-BF3FC3CAA2D5": {
  //   key: "examplePromo1",
  //   publish_at: "2024-03-10T11:30:00",
  //   unpublish_at: "2025-07-20T20:00:00",
  //   draw_end: "2025-03-20T20:05:00"
  // },
  // "EA2917A2-2D69-4E51-9E9E-A532CADCF887": {
  //   key: "examplePromo2",
  //   publish_at: "2024-03-24T11:30:00",
  //   unpublish_at: "2025-04-16T20:00:00",
  //   draw_end: "2025-04-11T22:05:00"
  // },
  // "D1C1B0B0-8E66-4E59-BD6A-92DB1196B25D": {
  //   key: "1DayTestForWebsite",
  //   publish_at: "2025-04-01T08:00:00",
  //   unpublish_at: "2025-06-02T18:00:00",
  //   draw_end: "2025-06-02T00:00:00-04:00" // TODO: Double check timezone on all these config dates
  // },
  // "1E0D1EA7-46BE-45D3-B99E-DDA84BED2DFE": {
  // "3BD44206-2BD6-44E1-8845-01C7A839ADF6": {
  //   key: "multiMillionaireMaker2025",
  //   drawType: "poker",
  //   publish_at: "2025-04-01T08:00:00",
  //   unpublish_at: "2025-06-02T18:00:00",
  //   earning_start: "2025-04-01T08:00:00", // Use the Eastern time that we need, but dont add the -04:00
  //   earning_end: "2025-06-01T23:59:59", // Use the Eastern time that we need, but dont add the -04:00
  //   draw_end: "2025-06-02T00:00:00" // Use the Eastern time that we need, but dont add the -04:00
  // },
  "521": {
    key: "hockeyNightAtPlayground2025",
    drawType: "egd",
    publish_at: "2026-02-01T09:00:00",
    earning_start: "2026-02-01T09:00:00", // Use the Eastern time that we need, but dont add the -04:00
    earning_end: "2026-03-01T19:30:00", // Use the Eastern time that we need, but dont add the -04:00
    draw_end: "2026-03-01T20:30:00", // Use the Eastern time that we need, but dont add the -04:00
    unpublish_at: "2026-03-01T21:00:00"
  },
  "534": {
    key: "hockeyNightAtPlayground2025",
    drawType: "egd",
    publish_at: "2026-03-01T21:00:00",
    earning_start: "2026-03-01T21:00:00", // Use the Eastern time that we need, but dont add the -04:00
    earning_end: "2026-04-01T19:30:00", // Use the Eastern time that we need, but dont add the -04:00
    draw_end: "2026-04-01T20:30:00", // Use the Eastern time that we need, but dont add the -04:00
    unpublish_at: "2026-04-01T21:00:00"
  },
  // Hockey Night - Oct 2026 (Sep 29 - Nov 5, draws Thu Nov 5 at 7PM & 8PM)
  "677": {
    key: "hockeyNightAtPlayground2026",
    drawType: "egd",
    publish_at: "2026-09-29T09:00:00",
    earning_start: "2026-09-29T09:00:00", // Use the Eastern time that we need, but dont add the -04:00
    earning_end: "2026-11-05T19:30:00", // Use the Eastern time that we need, but dont add the -04:00
    draw_end: "2026-11-05T20:30:00", // Use the Eastern time that we need, but dont add the -04:00
    unpublish_at: "2026-11-05T21:00:00"
  },
  "8B5BFDD4-8BAE-4C7D-9D65-9759E341D8A5": {
    key: "multiMillionaireMakerSeptember2025",
    drawType: "poker",
    publish_at: "2025-09-04T13:00:00",
    earning_start: "2025-09-08T09:00:00", // Use the Eastern time that we need, but dont add the -04:00
    earning_end: "2025-09-28T09:00:00", // Use the Eastern time that we need, but dont add the -04:00
    draw_end: "2025-09-28T19:00:00", // Use the Eastern time that we need, but dont add the -04:00
    unpublish_at: "2025-09-28T19:00:00"
  },
  // Triple Barrel Cash Blast February 2026 - Part 2 (Feb 2-15)
  "TRIPLE-BARREL-BLAST-FEBRUARY-2026-PT-2": {
    key: "tripleBarrelCashBlastFebruary2026",
    drawType: "poker",
    isMultiDraw: true,
    subDraws: [
      {
        promotionId: "0F676B91-3AC1-4192-8236-1A6889BA05F6",
        labelKey: "silver"
      },
      {
        promotionId: "F0E98862-2D0B-44AF-AF71-4E32A2C1A5AB",
        labelKey: "gold"
      },
      {
        promotionId: "69074CE9-D410-44F2-9484-70C0A716A6AE",
        labelKey: "diamond"
      }
    ],
    publish_at: "2026-02-01T20:00:00",
    earning_start: "2026-02-02T08:00:00",
    earning_end: "2026-02-15T08:00:00",
    draw_end: "2026-02-15T22:00:00",
    unpublish_at: "2026-02-16T01:00:00"
  },
  // Triple Barrel Cash Blast February 2026 - Part 3 (Feb 16 - Mar 1)
  "TRIPLE-BARREL-BLAST-FEBRUARY-2026-PT-3": {
    key: "tripleBarrelCashBlastFebruary2026",
    drawType: "poker",
    isMultiDraw: true,
    subDraws: [
      {
        promotionId: "11163EC3-E51C-4DAE-B8A0-D8F224BF22F1",
        labelKey: "silver"
      },
      {
        promotionId: "06D42FD6-8D26-40E4-8CE9-2D897C20AE0D",
        labelKey: "gold"
      },
      {
        promotionId: "EA75E5E4-C2DF-46CC-A79B-D362246AAA1C",
        labelKey: "diamond"
      }
    ],
    publish_at: "2026-02-16T01:00:00",
    earning_start: "2026-02-16T08:00:00",
    earning_end: "2026-03-01T08:00:00",
    draw_end: "2026-03-01T22:00:00",
    unpublish_at: "2026-03-02T01:00:00"
  },
  // Triple Barrel Cash Blast March 2026 (grouped multi-draw, silver/gold/diamond)
  "TRIPLE-BARREL-BLAST-MARCH-2026": {
    key: "tripleBarrelCashBlastMarch2026",
    drawType: "poker",
    isMultiDraw: true,
    subDraws: [
      {
        promotionId: "2843BF56-2823-4CF6-BBE8-03288562FD25",
        labelKey: "silver"
      },
      {
        promotionId: "530D5ED4-BB10-4FFA-A45A-9B273F076118",
        labelKey: "gold"
      },
      {
        promotionId: "BC00FC2E-FD80-4566-A81B-537FE65CDC67",
        labelKey: "diamond"
      }
    ],
    publish_at: "2026-03-02T00:10:00",
    earning_start: "2026-03-03T08:00:00",
    earning_end: "2026-03-22T21:55:00",
    draw_end: "2026-03-22T23:59:59",
    unpublish_at: "2026-03-23T01:00:00"
  },
  // WSOP Paradise Giveaway 2026 (cash-game entries only; Nov 2-15, draws Nov 16 12 PM-9 PM)
  "WSOP-PARADISE-GIVEAWAY-2026": {
    key: "wsopParadiseGiveaway2026",
    drawType: "poker",
    isMultiDraw: true,
    mergeTickets: true,
    subDraws: [
      { promotionId: "8E4708BA-60B3-435F-9D83-FA230F7D2501" }, // MAIN
      { promotionId: "99554756-D849-4FCE-9AA8-AB48CA00C732" }, // 2/2 PLO
      { promotionId: "CAB7228B-920B-4E58-826D-BCA02D258564" }, // 2/5
      { promotionId: "5FAB794F-3744-4806-9DCF-90C5E0685F6E" }, // 2/5 PLO
      { promotionId: "259F95F8-66B2-4EC4-9677-AD85B3F34959" }, // 5/5 PLO
      { promotionId: "17F4B197-3A4D-4216-A9C5-B4B107844FE4" }, // 5/10
      { promotionId: "FF1815EE-0802-4146-9672-BF24C35DBE9E" } // high stakes
    ],
    publish_at: "2026-10-30T09:00:00",
    earning_start: "2026-11-02T00:00:00",
    earning_end: "2026-11-15T23:59:59",
    draw_end: "2026-11-16T21:00:00",
    unpublish_at: "2026-11-16T22:00:00"
  },
  // Club Elite Saturday Draws - 2606 Week 1 (May 31 - Jun 6)
  "CLUB-ELITE-WEEK-1-2026-06": {
    key: "clubElite",
    drawType: "egd",
    isMultiDraw: true,
    mergeTickets: true,
    publish_at:     "2026-05-30T18:00:00",
    earning_start:  "2026-05-31T00:00:00", // Sunday 12:00 AM
    earning_end:    "2026-06-06T15:59:59", // Saturday 3:59 PM
    draw_end:       "2026-06-06T17:00:00",
    unpublish_at:   "2026-06-06T18:00:00",
    subDraws: [
      { promotionId: "593" },
      { promotionId: "589" }
    ]
  },
  // Club Elite Saturday Draws - 2606 Week 2 (Jun 7-13)
  "CLUB-ELITE-WEEK-2-2026-06": {
    key: "clubElite",
    drawType: "egd",
    isMultiDraw: true,
    mergeTickets: true,
    publish_at:     "2026-06-06T18:00:00",
    earning_start:  "2026-06-07T00:00:00", // Sunday 12:00 AM
    earning_end:    "2026-06-13T15:59:59", // Saturday 3:59 PM
    draw_end:       "2026-06-13T17:00:00",
    unpublish_at:   "2026-06-13T18:00:00",
    subDraws: [
      { promotionId: "594" },
      { promotionId: "590" }
    ]
  },
  // Club Elite Saturday Draws - 2606 Week 3 (Jun 14-20)
  "CLUB-ELITE-WEEK-3-2026-06": {
    key: "clubElite",
    drawType: "egd",
    isMultiDraw: true,
    mergeTickets: true,
    publish_at:     "2026-06-13T18:00:00",
    earning_start:  "2026-06-14T00:00:00", // Sunday 12:00 AM
    earning_end:    "2026-06-20T15:59:59", // Saturday 3:59 PM
    draw_end:       "2026-06-20T17:00:00",
    unpublish_at:   "2026-06-20T18:00:00",
    subDraws: [
      { promotionId: "595" },
      { promotionId: "591" }
    ]
  },
  // Club Elite Saturday Draws - 2606 Week 4 (Jun 21-27)
  "CLUB-ELITE-WEEK-4-2026-06": {
    key: "clubElite",
    drawType: "egd",
    isMultiDraw: true,
    mergeTickets: true,
    publish_at:     "2026-06-20T18:00:00",
    earning_start:  "2026-06-21T00:00:00", // Sunday 12:00 AM
    earning_end:    "2026-06-27T15:59:59", // Saturday 3:59 PM
    draw_end:       "2026-06-27T17:00:00",
    unpublish_at:   "2026-06-27T18:00:00",
    subDraws: [
      { promotionId: "596" },
      { promotionId: "592" }
    ]
  },
  // Spin & Spoil Mom 2026 (Apr 6 - May 10)
  "555": {
    key: "spinAndSpoilMom2026",
    drawType: "egd",
    publish_at: "2026-04-05T18:00:00",
    earning_start: "2026-04-06T00:00:00", // April 6 12:00 AM
    earning_end: "2026-05-10T18:55:00", // May 10 6:55 PM
    draw_end: "2026-05-10T20:00:00", // May 10 8:00 PM
    unpublish_at: "2026-05-10T21:00:00"
  },
  // Cashnado Spring 2026 - Week 6 (May 1)
  "561": {
    key: "cashnadoSpring2026",
    drawType: "egd",
    publish_at: "2026-04-22T19:00:00",
    earning_start: "2026-04-27T00:00:00",
    earning_end: "2026-05-01T17:55:00",
    draw_end: "2026-05-01T18:00:00",
    unpublish_at: "2026-05-01T19:00:00"
  },
  // Cashnado Spring 2026 - Week 7 (May 8)
  "562": {
    key: "cashnadoSpring2026",
    drawType: "egd",
    publish_at: "2026-05-01T19:00:00",
    earning_start: "2026-05-01T17:56:00",
    earning_end: "2026-05-08T17:55:00",
    draw_end: "2026-05-08T18:00:00",
    unpublish_at: "2026-05-08T19:00:00"
  },
  // Cashnado Spring 2026 - Week 8 (May 15)
  "563": {
    key: "cashnadoSpring2026",
    drawType: "egd",
    publish_at: "2026-05-08T19:00:00",
    earning_start: "2026-05-08T17:56:00",
    earning_end: "2026-05-15T17:55:00",
    draw_end: "2026-05-15T18:00:00",
    unpublish_at: "2026-05-15T19:00:00"
  },
  // Cashnado Spring 2026 - Week 9 (May 22)
  "564": {
    key: "cashnadoSpring2026",
    drawType: "egd",
    publish_at: "2026-05-15T19:00:00",
    earning_start: "2026-05-15T17:56:00",
    earning_end: "2026-05-22T17:55:00",
    draw_end: "2026-05-22T18:00:00",
    unpublish_at: "2026-05-22T19:00:00"
  },
  // Cashnado Spring 2026 - Week 10 (May 29)
  "565": {
    key: "cashnadoSpring2026",
    drawType: "egd",
    publish_at: "2026-05-22T19:00:00",
    earning_start: "2026-05-22T17:56:00",
    earning_end: "2026-05-29T17:55:00",
    draw_end: "2026-05-29T18:00:00",
    unpublish_at: "2026-05-29T19:00:00"
  },
  // Cashnado Spring 2026 - Week 11 (June 5)
  "566": {
    key: "cashnadoSpring2026",
    drawType: "egd",
    publish_at: "2026-05-29T19:00:00",
    earning_start: "2026-05-29T17:56:00",
    earning_end: "2026-06-05T17:55:00",
    draw_end: "2026-06-05T18:00:00",
    unpublish_at: "2026-06-05T19:00:00"
  },
  // Cashnado Spring 2026 - Week 12 (June 12)
  "567": {
    key: "cashnadoSpring2026",
    drawType: "egd",
    publish_at: "2026-06-05T19:00:00",
    earning_start: "2026-06-05T17:56:00",
    earning_end: "2026-06-12T17:55:00",
    draw_end: "2026-06-12T18:00:00",
    unpublish_at: "2026-06-12T19:00:00"
  },
  // Cashnado Spring 2026 - Week 13 (June 19)
  "568": {
    key: "cashnadoSpring2026",
    drawType: "egd",
    publish_at: "2026-06-12T19:00:00",
    earning_start: "2026-06-12T17:56:00",
    earning_end: "2026-06-19T17:55:00",
    draw_end: "2026-06-19T18:00:00",
    unpublish_at: "2026-06-19T19:00:00"
  },
  // Cashnado Spring 2026 - Week 14 (June 26)
  "569": {
    key: "cashnadoSpring2026",
    drawType: "egd",
    publish_at: "2026-06-19T19:00:00",
    earning_start: "2026-06-19T17:56:00",
    earning_end: "2026-06-26T17:55:00",
    draw_end: "2026-06-26T18:00:00",
    unpublish_at: "2026-06-26T19:00:00"
  },
  // Cashnado Spring 2026 - Week 15 (July 3)
  "570": {
    key: "cashnadoSpring2026",
    drawType: "egd",
    publish_at: "2026-06-26T19:00:00",
    earning_start: "2026-06-26T17:56:00",
    earning_end: "2026-07-03T17:55:00",
    draw_end: "2026-07-03T18:00:00",
    unpublish_at: "2026-07-03T19:00:00"
  },
  // Cashnado 2 Week 1 (Jul 4 - Jul 10)
  "609": {
    key: "cashnado2026",
    drawType: "egd",
    publish_at: "2026-07-03T19:00:00",
    earning_start: "2026-07-04T00:00:00",
    earning_end: "2026-07-10T17:55:00",
    draw_end: "2026-07-10T18:00:00",
    unpublish_at: "2026-07-10T19:00:00"
  },
  // Cashnado 2 Week 2 (Jul 10 - Jul 17)
  "610": {
    key: "cashnado2026",
    drawType: "egd",
    publish_at: "2026-07-10T19:00:00",
    earning_start: "2026-07-10T17:56:00",
    earning_end: "2026-07-17T17:55:00",
    draw_end: "2026-07-17T18:00:00",
    unpublish_at: "2026-07-17T19:00:00"
  },
  // Cashnado 2 Week 3 (Jul 17 - Jul 24)
  "611": {
    key: "cashnado2026",
    drawType: "egd",
    publish_at: "2026-07-17T19:00:00",
    earning_start: "2026-07-17T17:56:00",
    earning_end: "2026-07-24T17:55:00",
    draw_end: "2026-07-24T18:00:00",
    unpublish_at: "2026-07-24T19:00:00"
  },
  // Cashnado 2 Week 4 (Jul 24 - Jul 31)
  "612": {
    key: "cashnado2026",
    drawType: "egd",
    publish_at: "2026-07-24T19:00:00",
    earning_start: "2026-07-24T17:56:00",
    earning_end: "2026-07-31T17:55:00",
    draw_end: "2026-07-31T18:00:00",
    unpublish_at: "2026-07-31T19:00:00"
  },
  // Cashnado 2 Week 5 (Jul 31 - Aug 7)
  "613": {
    key: "cashnado2026",
    drawType: "egd",
    publish_at: "2026-07-31T19:00:00",
    earning_start: "2026-07-31T17:56:00",
    earning_end: "2026-08-07T17:55:00",
    draw_end: "2026-08-07T18:00:00",
    unpublish_at: "2026-08-07T19:00:00"
  },
  // Cashnado 2 Week 6 (Aug 7 - Aug 14)
  "614": {
    key: "cashnado2026",
    drawType: "egd",
    publish_at: "2026-08-07T19:00:00",
    earning_start: "2026-08-07T17:56:00",
    earning_end: "2026-08-14T17:55:00",
    draw_end: "2026-08-14T18:00:00",
    unpublish_at: "2026-08-14T19:00:00"
  },
  // Cashnado 2 Week 7 (Aug 14 - Aug 21)
  "615": {
    key: "cashnado2026",
    drawType: "egd",
    publish_at: "2026-08-14T19:00:00",
    earning_start: "2026-08-14T17:56:00",
    earning_end: "2026-08-21T17:55:00",
    draw_end: "2026-08-21T18:00:00",
    unpublish_at: "2026-08-21T19:00:00"
  },
  // Cashnado 2 Week 8 (Aug 21 - Aug 28)
  "616": {
    key: "cashnado2026",
    drawType: "egd",
    publish_at: "2026-08-21T19:00:00",
    earning_start: "2026-08-21T17:56:00",
    earning_end: "2026-08-28T17:55:00",
    draw_end: "2026-08-28T18:00:00",
    unpublish_at: "2026-08-28T19:00:00"
  },
  // Cashnado 2 Week 9 (Aug 28 - Sep 4)
  "617": {
    key: "cashnado2026",
    drawType: "egd",
    publish_at: "2026-08-28T19:00:00",
    earning_start: "2026-08-28T17:56:00",
    earning_end: "2026-09-04T17:55:00",
    draw_end: "2026-09-04T18:00:00",
    unpublish_at: "2026-09-04T19:00:00"
  },
  // Cashnado 2 Week 10 (Sep 4 - Sep 11)
  "618": {
    key: "cashnado2026",
    drawType: "egd",
    publish_at: "2026-09-04T19:00:00",
    earning_start: "2026-09-04T17:56:00",
    earning_end: "2026-09-11T17:55:00",
    draw_end: "2026-09-11T18:00:00",
    unpublish_at: "2026-09-11T19:00:00"
  },
  // Cashnado 2 Week 11 (Sep 11 - Sep 18)
  "619": {
    key: "cashnado2026",
    drawType: "egd",
    publish_at: "2026-09-11T19:00:00",
    earning_start: "2026-09-11T17:56:00",
    earning_end: "2026-09-18T17:55:00",
    draw_end: "2026-09-18T18:00:00",
    unpublish_at: "2026-09-18T19:00:00"
  },
  // Cashnado 2 Week 12 (Sep 18 - Sep 25)
  "620": {
    key: "cashnado2026",
    drawType: "egd",
    publish_at: "2026-09-18T19:00:00",
    earning_start: "2026-09-18T17:56:00",
    earning_end: "2026-09-25T17:55:00",
    draw_end: "2026-09-25T18:00:00",
    unpublish_at: "2026-09-25T19:00:00"
  },
  // Cashnado 2 Week 13 (Sep 25 - Oct 2)
  "621": {
    key: "cashnado2026",
    drawType: "egd",
    publish_at: "2026-09-25T19:00:00",
    earning_start: "2026-09-25T17:56:00",
    earning_end: "2026-10-02T17:55:00",
    draw_end: "2026-10-02T18:00:00",
    unpublish_at: "2026-10-02T19:00:00"
  },
  // Cashnado 2 Week 14 (Oct 2 - Oct 9)
  "622": {
    key: "cashnado2026",
    drawType: "egd",
    publish_at: "2026-10-02T19:00:00",
    earning_start: "2026-10-02T17:56:00",
    earning_end: "2026-10-09T17:55:00",
    draw_end: "2026-10-09T18:00:00",
    unpublish_at: "2026-10-09T19:00:00"
  },
  // Cashnado 2 Week 15 (Oct 9 - Oct 16)
  "623": {
    key: "cashnado2026",
    drawType: "egd",
    publish_at: "2026-10-09T19:00:00",
    earning_start: "2026-10-09T17:56:00",
    earning_end: "2026-10-16T17:55:00",
    draw_end: "2026-10-16T18:00:00",
    unpublish_at: "2026-10-16T19:00:00"
  },
  // Cashnado 2 Week 16 (Oct 16 - Oct 23)
  "624": {
    key: "cashnado2026",
    drawType: "egd",
    publish_at: "2026-10-16T19:00:00",
    earning_start: "2026-10-16T17:56:00",
    earning_end: "2026-10-23T17:55:00",
    draw_end: "2026-10-23T18:00:00",
    unpublish_at: "2026-10-23T19:00:00"
  },
  // Cashnado 2 Week 17 (Oct 23 - Oct 30)
  "625": {
    key: "cashnado2026",
    drawType: "egd",
    publish_at: "2026-10-23T19:00:00",
    earning_start: "2026-10-23T17:56:00",
    earning_end: "2026-10-30T17:55:00",
    draw_end: "2026-10-30T18:00:00",
    unpublish_at: "2026-10-30T19:00:00"
  },
  // Cashnado 2 Week 18 (Oct 30 - Nov 6)
  "626": {
    key: "cashnado2026",
    drawType: "egd",
    publish_at: "2026-10-30T19:00:00",
    earning_start: "2026-10-30T17:56:00",
    earning_end: "2026-11-06T17:55:00",
    draw_end: "2026-11-06T18:00:00",
    unpublish_at: "2026-11-06T19:00:00"
  },
  // Cashnado 2 Week 19 (Nov 6 - Nov 13)
  "627": {
    key: "cashnado2026",
    drawType: "egd",
    publish_at: "2026-11-06T19:00:00",
    earning_start: "2026-11-06T17:56:00",
    earning_end: "2026-11-13T17:55:00",
    draw_end: "2026-11-13T18:00:00",
    unpublish_at: "2026-11-13T19:00:00"
  },
  // Cashnado 2 Week 20 (Nov 13 - Nov 20)
  "628": {
    key: "cashnado2026",
    drawType: "egd",
    publish_at: "2026-11-13T19:00:00",
    earning_start: "2026-11-13T17:56:00",
    earning_end: "2026-11-20T17:55:00",
    draw_end: "2026-11-20T18:00:00",
    unpublish_at: "2026-11-20T19:00:00"
  },
  // Cashnado 2 Week 21 (Nov 20 - Nov 27)
  "629": {
    key: "cashnado2026",
    drawType: "egd",
    publish_at: "2026-11-20T19:00:00",
    earning_start: "2026-11-20T17:56:00",
    earning_end: "2026-11-27T17:55:00",
    draw_end: "2026-11-27T18:00:00",
    unpublish_at: "2026-11-27T19:00:00"
  },
  // Cashnado 2 Week 22 (Nov 27 - Dec 4)
  "630": {
    key: "cashnado2026",
    drawType: "egd",
    publish_at: "2026-11-27T19:00:00",
    earning_start: "2026-11-27T17:56:00",
    earning_end: "2026-12-04T17:55:00",
    draw_end: "2026-12-04T18:00:00",
    unpublish_at: "2026-12-04T19:00:00"
  },
  // Cashnado 2 Week 23 (Dec 4 - Dec 11)
  "631": {
    key: "cashnado2026",
    drawType: "egd",
    publish_at: "2026-12-04T19:00:00",
    earning_start: "2026-12-04T17:56:00",
    earning_end: "2026-12-11T17:55:00",
    draw_end: "2026-12-11T18:00:00",
    unpublish_at: "2026-12-11T19:00:00"
  },
  // Cashnado 2 Week 24 (Dec 11 - Dec 18)
  "632": {
    key: "cashnado2026",
    drawType: "egd",
    publish_at: "2026-12-11T19:00:00",
    earning_start: "2026-12-11T17:56:00",
    earning_end: "2026-12-18T17:55:00",
    draw_end: "2026-12-18T18:00:00",
    unpublish_at: "2026-12-18T19:00:00"
  },
  // Cashnado 2 Week 25 (Dec 18 - Dec 25)
  "634": {
    key: "cashnado2026",
    drawType: "egd",
    publish_at: "2026-12-18T19:00:00",
    earning_start: "2026-12-18T17:56:00",
    earning_end: "2026-12-25T17:55:00",
    draw_end: "2026-12-25T18:00:00",
    unpublish_at: "2026-12-25T19:00:00"
  },
  // Cashnado 2 Week 26 (GF) (Dec 25 - Jan 1)
  "635": {
    key: "cashnado2026",
    drawType: "egd",
    publish_at: "2026-12-25T19:00:00",
    earning_start: "2026-12-25T17:56:00",
    earning_end: "2027-01-01T17:55:00",
    draw_end: "2027-01-01T18:00:00",
    unpublish_at: "2027-01-01T19:00:00"
  },
  // Birthday Bash - June 2026 (Jun 1-29)
  "478": {
    key: "birthdayBash2025",
    drawType: "egd",
    publish_at: "2026-06-01T09:00:00",
    earning_start: "2026-06-01T09:00:00",
    earning_end: "2026-06-29T23:59:59",
    draw_end: "2026-06-29T23:59:59",
    unpublish_at: "2026-06-30T01:00:00"
  },
  // Birthday Bash - July 2026 (Jul 1-27)
  "537": {
    key: "birthdayBash2025",
    drawType: "egd",
    publish_at: "2026-07-01T09:00:00",
    earning_start: "2026-07-01T09:00:00",
    earning_end: "2026-07-27T23:59:59",
    draw_end: "2026-07-27T23:59:59",
    unpublish_at: "2026-07-28T01:00:00"
  },
  // Birthday Bash - August 2026 (Aug 1-31)
  "538": {
    key: "birthdayBash2025",
    drawType: "egd",
    publish_at: "2026-08-01T09:00:00",
    earning_start: "2026-08-01T09:00:00",
    earning_end: "2026-08-31T23:59:59",
    draw_end: "2026-08-31T23:59:59",
    unpublish_at: "2026-09-01T01:00:00"
  },
  // Birthday Bash - September 2026 (Sep 1-28)
  "539": {
    key: "birthdayBash2025",
    drawType: "egd",
    publish_at: "2026-09-01T09:00:00",
    earning_start: "2026-09-01T09:00:00",
    earning_end: "2026-09-28T23:59:59",
    draw_end: "2026-09-28T23:59:59",
    unpublish_at: "2026-09-29T01:00:00"
  },
  // Birthday Bash - October 2026 (Oct 1-26, draw on last Monday Oct 26)
  "540": {
    key: "birthdayBash2025",
    drawType: "egd",
    publish_at: "2026-10-01T09:00:00",
    earning_start: "2026-10-01T09:00:00",
    earning_end: "2026-10-26T23:59:59",
    draw_end: "2026-10-26T23:59:59",
    unpublish_at: "2026-10-27T01:00:00"
  },
  // Birthday Bash - November 2026 (Nov 1-30)
  "541": {
    key: "birthdayBash2025",
    drawType: "egd",
    publish_at: "2026-11-01T09:00:00",
    earning_start: "2026-11-01T09:00:00",
    earning_end: "2026-11-30T23:59:59",
    draw_end: "2026-11-30T23:59:59",
    unpublish_at: "2026-12-01T01:00:00"
  },
  // Birthday Bash - December 2026 (Dec 1-28)
  "542": {
    key: "birthdayBash2025",
    drawType: "egd",
    publish_at: "2026-12-01T09:00:00",
    earning_start: "2026-12-01T09:00:00",
    earning_end: "2026-12-28T23:59:59",
    draw_end: "2026-12-28T23:59:59",
    unpublish_at: "2026-12-29T01:00:00"
  }
};

// In Cypress test environment, use test config with fixed dates.
// `window.Cypress` keeps this reliable even when REACT_APP_* env vars are not
// injected into an already-running dev server.
const isCypressRuntime = typeof window !== 'undefined' && Boolean(window.Cypress);
if (process.env.REACT_APP_CYPRESS_TEST === 'true' || isCypressRuntime) {
  promoDrawsScheduleConfig = testConfig;
}

export default promoDrawsScheduleConfig;
